import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export type SimpleResponse = {
  e: 'SUCCESS' | 'CANCEL' | 'TIMEOUT' | 'DIJB'; // TODO
  m: string;
  o: string;
  r: number;
  t: number;
};

const OtpRedirectPage = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const r = params.get('r');
    if (r) {
      const responseDecoded = JSON.parse(window.atob(r)) as SimpleResponse;

      localStorage.setItem('otp', JSON.stringify(responseDecoded));
      navigate(`/orders/${responseDecoded.o}/status`);
    } else {
      setError('Valami hiba történt');
    }
  }, [location, navigate]);

  if (error) {
    return (
      <div>
        <div>{error}</div>
        <div>search URL: {location.search}</div>
      </div>
    );
  }

  return <div>loading..</div>;
};
export default OtpRedirectPage;
